import React from 'react'
import { cn } from 'cn'
import Link from 'next/link'
import Image from 'components/Image'
import useTheme from 'lib/theme/useTheme'

import { useHeaderConfig } from 'components/Header/HeaderProvider/useHeaderConfig'
import MenuItem from 'components/Header/components/common/MenuItem'
import CartComponent from 'components/Header/CartComponent'

import CloseMobileMenuButton from './CloseMobileMenuButton'
import OpenMobileMenuButton from './OpenMobileMenuButton'

const MainMobileMenu = ({
  isOpenMenu,
  openMenu,
  closeMenu,
  headerAction,
  hideHeader,
  hideNavigation,
  highlightCartItems
}: {
  isOpenMenu: boolean
  openMenu: () => void
  closeMenu: () => void
  headerAction?: React.ReactNode
  hideHeader: boolean
  hideNavigation: boolean
  highlightCartItems: boolean
}) => {
  const { logoUrl } = useHeaderConfig()
  const { theme } = useTheme()
  const themedHeader = theme.page.themedBackground

  return (
    <div
      className={cn(
        'flex fixed w-full lg:hidden justify-between items-center py-3 px-2 shadow-sm transition-all duration-500 ease-in-out translate-y-0 z-30',
        {
          '-translate-y-full': hideHeader,
          'bg-white border-gray-100': !themedHeader,
          'bg-theme-primary text-theme-primary-text font-theme-body':
            themedHeader
        }
      )}
    >
      <div
        className={cn('flex-none px-2', {
          'border-r border-solid border-gray-300': !themedHeader
        })}
      >
        <Link href="/" prefetch={false}>
          <Image alt="BFT logo" width={56} height={32} src={logoUrl} />
        </Link>
      </div>
      {!hideNavigation ? (
        <div
          className={cn(
            'border-r border-solid px-2 flex items-center justify-center grow',
            {
              'border-gray-300': !themedHeader,
              'border-white/30': themedHeader
            }
          )}
        >
          <MenuItem
            href="/food-trucks-near-me"
            title="Trucks nearby"
            titleClassName="text-xs xs:text-base"
          />
        </div>
      ) : headerAction ? (
        <div className="grow px-2">{headerAction}</div>
      ) : null}
      {!theme.page.hideCart && (
        <div
          className={cn('border-r border-solid grow flex justify-center px-2', {
            'border-gray-300': !themedHeader,
            'border-white/30': themedHeader
          })}
        >
          <CartComponent highlightCartItems={highlightCartItems} />
        </div>
      )}
      <div className="flex-none px-2">
        {isOpenMenu ? (
          <CloseMobileMenuButton onClick={closeMenu} />
        ) : (
          <OpenMobileMenuButton onClick={openMenu} />
        )}
      </div>
    </div>
  )
}

export default MainMobileMenu
